import {Injectable} from '@angular/core';
import {ApiLocationService} from '@services/api-location/api-location.service';
import { HttpClient } from '@angular/common/http';
import {
  OrganizationsPageResponse
} from '@models/adminstration/organization/organizations-page-response/organizations-page-response';
import {Observable, of} from 'rxjs';
import {Machine} from '@models/machine/machine';
import {User} from '@models/user/user';
import {Organization} from '@models/organization/organization';
import {shareReplay} from 'rxjs/operators';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  private ORGANIZATION_LIST_URL_SUFFIX = '/api/web/admin/tenant/list/:limit/:cursor';
  private ORGANIZATION_DELETE_URL_SUFFIX = '/api/web/admin/tenant/:id';
  private ORGANIZATION_LIST_MACHINES_URL_SUFFIX = '/api/web/admin/tenant/:id/machines';
  private ORGANIZATION_RESTRICTED_INTERACTIONS_URL_SUFFIX = '/api/web/admin/tenant/restrictedTenantInteraction';
  private ORGANIZATION_DATASET_NAME_CHECK_URL_SUFFIX = '/api/web/admin/tenant/isDatasetNameUsed?dataset=:dataset';
  private ORGANIZATION_LIST_USERS_URL_SUFFIX = '/api/web/admin/tenant/:id/users';
  private ORGANIZATION_LIST_SUB_ORGANISATIONS_URL_SUFFIX = '/api/web/admin/tenant/:id/subTenants';
  private ORGANIZATION_LIST_POSSIBLE_PARENTS_URL_SUFFIX = '/api/web/admin/tenant/:id/possibleParents';
  private ORGANIZATION_SAVE_URL_SUFFIX = '/api/web/admin/tenant/:id';
  private ORGANIZATION_AGREEMENTS_RESET_URL_SUFFIX = '/api/web/admin/tenant/:id/resetUserAgreement';

  private organizationsResponseCache = new Map();
  private readonly BASE_URL: string;

  constructor(private http: HttpClient,
              private apiLocation: ApiLocationService) {
    this.BASE_URL = this.apiLocation.getLocation();
  }
  /**
   * @deprecated - should use elastic search approach
   */
  public list(cursor: string, limit: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_LIST_URL_SUFFIX;
    url = url.replace(':limit', String(limit)).replace(':cursor', cursor);
    const organisationsFromCache = this.organizationsResponseCache.get(url);
    if (organisationsFromCache) {
      return of(organisationsFromCache);
    }
    console.debug('organizations list url: ' + url);
    const response = this.http.get<OrganizationsPageResponse>(url, HTTPS_REQUEST_OPTIONS).pipe(shareReplay({
      bufferSize: 1,
      refCount: true
    }));
    response.subscribe((result) => {
      this.organizationsResponseCache.set(url, result);
    });
    return response;
  }

  public restrictedOrganizationInteraction(): Observable<any> {
    const url: string = this.BASE_URL + this.ORGANIZATION_RESTRICTED_INTERACTIONS_URL_SUFFIX;


    return this.http.get<Machine[]>(url, HTTPS_REQUEST_OPTIONS);
  }
  /**
   * @deprecated - should use elastic search approach
   */
  public listMachines(organizationId: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_LIST_MACHINES_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));

    return this.http.get<Machine[]>(url, HTTPS_REQUEST_OPTIONS);
  }
  /**
   * @deprecated - should use elastic search approach
   */
  public listUsers(organizationId: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_LIST_USERS_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));

    return this.http.get<User[]>(url, HTTPS_REQUEST_OPTIONS);

  }
  /**
   * @deprecated - should use elastic search approach
   */
  public listSubOrganizations(organizationId: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_LIST_SUB_ORGANISATIONS_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));

    return this.http.get<Organization[]>(url, HTTPS_REQUEST_OPTIONS);
  }

  public delete(organizationId: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_DELETE_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));

    return this.http.delete(url, HTTPS_REQUEST_OPTIONS);
  }

  public listPossibleOrganizationParents(organizationId: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_LIST_POSSIBLE_PARENTS_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));

    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }

  public isDatasetNameUsed(datasetName: string): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_DATASET_NAME_CHECK_URL_SUFFIX;
    url = url.replace(':dataset', datasetName);
    console.debug('url: ' + url);
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }

  public saveOrganization(organization: Organization): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_SAVE_URL_SUFFIX;
    if (organization.id > 0) {
      url = url.replace(':id', String(organization.id));
    } else {
      url = url.replace(':id', '');
    }

    return this.http.post(url, organization, HTTPS_REQUEST_OPTIONS);
  }

  public resetUsersAgreements(organization: Organization): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_AGREEMENTS_RESET_URL_SUFFIX;
    url = url.replace(':id', String(organization.id));
    console.debug('url: ' + url);
    return this.http.post(url, organization, HTTPS_REQUEST_OPTIONS);

  }

  public getOrganizationDetails(organizationId: number): Observable<any> {
    let url: string = this.BASE_URL + this.ORGANIZATION_SAVE_URL_SUFFIX;
    url = url.replace(':id', String(organizationId));
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }

}
